import cdEnum from './cdEnum'
import cdCurrency from './cdCurrency'
import cpfCnpjFormatter from './cpfCnpjFormatter'

export default {
    install(Vue) {
        Vue.filter('cdEnum', cdEnum)
        Vue.filter('cdCurrency', cdCurrency)
        Vue.filter('cpfCnpjFormatter', cpfCnpjFormatter)
    }
}
